import * as React from "react"

const LineColor5 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                width={2}
                height={44}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 2 44`}


            >
                <path
                    id={"line-color-5"}

                    ref={pathRef}
                    d="M0 0V44H2V0H0Z" fill="#4361EE"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                />
            </svg>
        )
    }
)

export default LineColor5
